// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btnRadio > .input-group-text {\n    border: none;\n    background: none;\n}\n\n.areaOpt , .areaOpt:focus {\n    box-shadow: none;\n    border: none !important;\n}", ""]);
// Exports
module.exports = exports;
